import React, { useEffect, useState } from 'react';
import { Box, Button, FormControl, FormErrorMessage, FormLabel, Grid, Input, Select } from '@chakra-ui/react';
import { AdminActions } from '../AdminLayout/AdminLayout';
import { ChevronDownIcon } from '../AdminIcon';
import { dateRangePresets, presetDateRange } from './dateRanges';

/** Presets apply immediately; custom dates remain a draft until Apply is pressed. */
export default function AdminDateRange({ value, onChange, allowAllTime = false }) {
  const [selected, setSelected] = useState(value.preset);
  const [start, setStart] = useState(value.start || '');
  const [end, setEnd] = useState(value.end || '');
  const invalid = Boolean(start && end && end < start);
  useEffect(() => { setSelected(value.preset); }, [value.preset]);

  const selectPreset = event => {
    const preset = event.target.value;
    setSelected(preset);
    if (preset === 'custom') {
      setStart(value.start || '');
      setEnd(value.end || '');
    } else {
      onChange(presetDateRange(preset));
    }
  };
  return (
    <Box className="admin-date-range">
      <Grid gap={4} alignItems="start"
        templateColumns={selected === 'custom'
          ? { base: 'repeat(2, minmax(0, 1fr))', md: 'minmax(160px, 240px) repeat(2, minmax(160px, 200px)) max-content' }
          : { base: 'minmax(0, 1fr)', md: 'minmax(160px, 240px)' }}>
        <FormControl gridColumn={{ base: '1 / -1', md: 'auto' }}>
          <FormLabel>Date range</FormLabel>
          <Select icon={<ChevronDownIcon />} value={selected} onChange={selectPreset}>
            {allowAllTime && <option value="all">All time</option>}
            {dateRangePresets.map(([key, label]) => <option key={key} value={key}>{label}</option>)}
            <option value="custom">Custom range</option>
          </Select>
        </FormControl>
        {selected === 'custom' && <>
          <FormControl>
            <FormLabel>Start date</FormLabel>
            <Input type="date" value={start} onChange={event => setStart(event.target.value)} />
          </FormControl>
          <FormControl isInvalid={invalid}>
            <FormLabel>End date</FormLabel>
            <Input type="date" value={end} min={start || undefined} onChange={event => setEnd(event.target.value)} />
            <FormErrorMessage>End date must be on or after the start date.</FormErrorMessage>
          </FormControl>
          <AdminActions alignSelf="end" gridColumn={{ base: '1 / -1', md: 'auto' }}>
            <Button colorScheme="blue" onClick={() => onChange({ preset: 'custom', start, end })} isDisabled={!start || !end || invalid}>Apply</Button>
          </AdminActions>
        </>}
      </Grid>
    </Box>
  );
}
